export class ConfirmDialogOptions
{
    constructor(
        public title: string,
        public message: string
    )
    {

    }
    disableClose: true
}